import { useRef, useEffect } from 'react';

import PositionedTooltip from 'generics/components/positioned-tooltip';

function DisabledTooltip(props) {

  const tooltip = useRef(null);

  if (tooltip.current === null) {
    tooltip.current = new PositionedTooltip();
  }

  useEffect(function syncVisibility() {

    if (props.visible === true && props.anchorElement !== null) {
      tooltip.current.show(props.anchorElement, props.text);
      return;
    }

    tooltip.current.hideWithDelay();

  }, [props.visible, props.anchorElement]);

  useEffect(function cleanup() {

    return function hideOnUnmount() {
      tooltip.current.hide();
    };

  }, []);

  return null;

}

export default DisabledTooltip;
